const topics = [
  { label: '流浪地球3', count: '128万讨论', hot: true },
  { label: '暑期档', count: '96万讨论', hot: true },
  { label: '悬疑片推荐', count: '84万讨论', hot: true },
  { label: '国产剧', count: '73万讨论', hot: false },
  { label: '动画电影', count: '68万讨论', hot: false },
  { label: '科幻大片', count: '62万讨论', hot: false },
  { label: '韩剧热播', count: '57万讨论', hot: false },
  { label: '高分冷门', count: '51万讨论', hot: false },
  { label: '纪录片', count: '46万讨论', hot: false },
  { label: '经典重温', count: '42万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-500 text-sm">全网影迷正在热议的影视话题，加入讨论</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <div
                key={i}
                className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                  topic.hot
                    ? 'bg-primary-100/70 border-primary-200 text-primary-700 hover:bg-primary-200'
                    : 'bg-background-100 border-background-200/60 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
                }`}
              >
                {topic.hot && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-fire-fill text-accent-500 text-xs"></i>
                  </span>
                )}
                <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
                <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                  {topic.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}